// @flow

import { put, takeEvery } from 'redux-saga/effects';
import {
    GET_COMMENTS,
} from './../types/comments';

import {
    getCommentsSuccess,
    getCommentsFail,
} from './../actions/comments';
import { getBaseUrl } from './../reducers/domainProperties';

const BASE_URL = getBaseUrl();

export function* getCommentsSaga(action: AuthAction): Generator<any, void, any> {
    try {
        const { axiosInstance } = action;
        const { data } = yield axiosInstance.get(`${BASE_URL}comments`);
        yield put(getCommentsSuccess(data));
    } catch (error) {
        yield put(getCommentsFail(error));
    }
}

export function* watchGetComments(): Generator<any, void, any> {
    yield takeEvery(GET_COMMENTS, getCommentsSaga);
};



// WEBPACK FOOTER //
// ./src/sagas/comments.jsx